export const workspaceTitles = ['рабочее место', 'рабочих мест'];
export const performersTitles = ['исполнитель', 'исполнителя'];

export const getNumberCurrying = (number, titles) => {
  let cases = [2, 0, 1, 1, 1, 2];
  number = Math.abs(number);
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 1
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
};
